module.exports = __webpack_public_path__ + "static/EduardoLepineCV-d29761545199d1d27ea7b6be20250126.pdf";